import InputDropdownComponent from '../components/inputs/InputDropdownComponent';

export const VehicleTrailerOrderFuel = (props) => {
    const {t, element, handleChange, validator, vehicleOpt, trailerOpt, filterByWholeName} = props;
    return (
        <div className='row'>
            <InputDropdownComponent
                id='vehicle'
                name='vehicle'
                label={t('order-fuel.vehicle')}
                colClass='col-lg-4 col-md-8 col-sm-12'
                value={element.vehicle}
                viewMode='EDIT'
                validator={validator}
                validators='required'
                options={vehicleOpt}
                onChange={handleChange}
                dataKey='sapId'
                optionLabel='sapId'
                valueTemplate={
                    element.vehicle
                        ? (r) => {
                              return `${r?.registrationNumber} (${!!r?.own ? t('trailer.own-true') : t('trailer.own-false')})`;
                          }
                        : undefined
                }
                itemTemplate={(r) => {
                    return (
                        <li
                            className='p-dropdown-item'
                            aria-label={`${r.registrationNumber} (${!!r.own ? t('trailer.own-true') : t('trailer.own-false')})`}
                            role='option'
                            aria-selected='false'
                        >{`${r.registrationNumber} (${!!r.own ? t('trailer.own-true') : t('trailer.own-false')})`}</li>
                    );
                }}
                filter
                filterBy={filterByWholeName === false  ? 'registrationNumber' : 'wholeName'}          
            />
            <InputDropdownComponent
                id='trailer'
                name='trailer'
                label={t('order-fuel.trailer')}
                colClass='col-lg-4 col-md-8 col-sm-12'
                value={element.trailer}
                viewMode='EDIT'
                validator={validator}
                validators={element?.vehicle?.type === 'Y5' ? 'not_required' : 'required'}
                options={trailerOpt}
                onChange={handleChange}
                dataKey='sapId'
                optionLabel='sapId'
                valueTemplate={
                    element.trailer
                        ? (r) => {
                              return `${r?.registrationNumber} (${t(`EcTrailerType.${r?.type}`)}, ${
                                  !!r?.own ? t('trailer.own-true') : t('trailer.own-false')
                              })`;
                          }
                        : undefined
                }
                itemTemplate={(r) => {
                    return (
                        <li
                            className='p-dropdown-item'
                            aria-label={`${r.registrationNumber} (${t(`EcTrailerType.${r.type}`)}, ${
                                !!r.own ? t('trailer.own-true') : t('trailer.own-false')
                            })`}
                            role='option'
                            aria-selected='false'
                        >{`${r.registrationNumber} (${t(`EcTrailerType.${r.type}`)}, ${
                            !!r.own ? t('trailer.own-true') : t('trailer.own-false')
                        })`}</li>
                    );
                }}
                filter
                filterBy={filterByWholeName === false  ? 'registrationNumber' : 'wholeName'}
            />
        </div>
    );
};
